import { Box, Button, Stack, Text } from '@chakra-ui/react'
import { useSlate } from 'slate-react'

import { InputText } from '../../Form/styled'
import ModalV3 from '../../Modal/ModalV3'
import { insertLink, isLinkActive, unwrapLink } from './inlines'

export default function CreateOrUpdateHyperlinkModal({
  showModal,
  setShowModal,
  link,
  setLink,
}: {
  showModal: boolean
  setShowModal: (show: boolean) => void
  link: string
  setLink: (link: string) => void
}): React.ReactElement {
  const editor = useSlate()
  return (
    <ModalV3
      size="lg"
      title="Hyperlink"
      open={showModal}
      onClose={() => {
        setShowModal(false)
      }}
      rightFooterContent={() => (
        <Stack justify="flex-end" spacing={2} direction="row" mt={4}>
          {isLinkActive(editor) ? (
            <Button
              variant="danger-outline"
              onClick={() => {
                unwrapLink(editor)
                setShowModal(false)
              }}
            >
              Remove
            </Button>
          ) : null}
          <Button
            type="submit"
            onClick={() => {
              if (link != null) {
                insertLink(editor, link)
              }
              setShowModal(false)
            }}
          >
            Save
          </Button>
        </Stack>
      )}
      body={() => (
        <Box>
          <Text fontWeight="bold" mb={2}>
            Please enter a URL:
          </Text>
          <InputText
            type="text"
            value={link ?? undefined}
            placeholder="https://schoolhouse.world"
            onInput={e => setLink((e.target as HTMLInputElement).value)}
          />
        </Box>
      )}
    />
  )
}
